import authReducer from "./Reducers/authReducer";
import bannerReducer from "./Reducers/bannerReducer";
import categoryReducer from "./Reducers/categoryReducer";
import chatReducer from "./Reducers/chatReducer";
import dashboardReducer from "./Reducers/dashboardReducer";
import OrderReducer from "./Reducers/OrderReducer";
import PaymentReducer from "./Reducers/PaymentReducer";
import productReducer from "./Reducers/productReducer";
import sellerReducer from "./Reducers/sellerReducer";
import ordersReducer from "./features/orders/ordersSlice";
import allProductsReducer from "./features/allProducts/allProductsSlice";
import categoriesReducer from "./features/categories/categoriesSlice";
import bugReportsReducer from "./features/bug-reports/bugReportsSlice";
import productPhotosReducer from "./features/product-photos/productPhotosSlice";
import pickupRequestsReducer from "./features/pickupRequests/pickupRequestsSlice";
import shippingFeesReducer from "./features/shippingFees/shippingFeesSlice";
import bannersReducer from "./features/banners/bannersSlice";
import sellerBannersReducer from "./features/seller-banners/sellerBannersSlice";
import discountProductsReducer from "./features/discountProducts/discountProductsSlice";
import sellersReducer from "./features/sellers/sellersSlice";
import refundsReducer from "./features/refunds/refundsSlice";
import locationReducer from "./features/locations/locationSlice";
import affiliateOrdersReducer from "./features/affiliate-orders/affiliateOrdersSlice";
import payoutsReducer from "./features/payouts/payoutsSlice";

const rootReducer = {
    auth: authReducer,
    category: categoryReducer,
    product: productReducer,
    seller: sellerReducer,
    chat: chatReducer,
    order: OrderReducer,
    payment: PaymentReducer,
    dashboard: dashboardReducer,
    banner: bannerReducer,
    orders: ordersReducer,
    affiliateOrders: affiliateOrdersReducer,
    allProducts: allProductsReducer,
    discountProducts: discountProductsReducer,
    categories: categoriesReducer,
    bugReports: bugReportsReducer,
    productPhotos: productPhotosReducer,
    pickupRequests: pickupRequestsReducer,
    shippingFees: shippingFeesReducer,
    banners: bannersReducer,
    sellerBanners: sellerBannersReducer,
    sellers: sellersReducer,
    refunds: refundsReducer,
    payouts: payoutsReducer,
    location: locationReducer,
};

export default rootReducer;
